import { Apps, FormatListBulleted } from "@mui/icons-material";
import { Divider, Grid, IconButton, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import React, { useState } from "react";
import Job from "../../Homepage Components/Latest Job/Job";
import { tokens } from "../../../store/tokens";

const Jobs = (props) => {
  const { jobListData } = props;
  const [viewMode, setViewMode] = useState("list");

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Stack
        direction="row"
        justifyContent={"space-between"}
        alignItems="center"
        sx={{ pb: 1.5 }}
      >
        <Typography variant="subtitle1" sx={{ color: tokens.color.ink }}>
          Jobs
        </Typography>

        {/* The icons/state for this toggle were already imported before —
            they just never drove anything, so every job list rendered as
            a single column regardless of which button (if any) you'd
            expect to press. */}
        <Stack direction="row" spacing={0.5}>
          <IconButton
            size="small"
            onClick={() => setViewMode("list")}
            sx={{
              color: viewMode === "list" ? tokens.color.teal : tokens.color.inkFaint,
              bgcolor: viewMode === "list" ? tokens.color.tealLight : "transparent",
            }}
          >
            <FormatListBulleted fontSize="small" />
          </IconButton>
          <IconButton
            size="small"
            onClick={() => setViewMode("grid")}
            sx={{
              color: viewMode === "grid" ? tokens.color.teal : tokens.color.inkFaint,
              bgcolor: viewMode === "grid" ? tokens.color.tealLight : "transparent",
            }}
          >
            <Apps fontSize="small" />
          </IconButton>
        </Stack>
      </Stack>
      <Divider sx={{ mb: 2, borderColor: tokens.color.line }} />

      <Grid container spacing={2}>
        {jobListData.map((data) => (
          <Grid
            item
            xs={12}
            md={viewMode === "grid" ? 6 : 12}
            key={data.job_id ?? data.job_refer}
          >
            <Job jobData={data} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Jobs;
